import type { VesselCallError } from "@features/vessel-call/vessel-call-status/VesselCallStatus.types.tsx";
import type { CancelVesselCallByIdArgs } from "@services/vesselCall/types";
import { cancelVesselCallById } from "@services/vesselCallApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useCancelVesselCall = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: (status?: string) => void;
  handleError: (error: VesselCallError) => void;
}) => {
  const cancelCallMutation = useMutation({
    mutationFn: (variables: Parameters<typeof cancelVesselCallById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "VesselCallStatus",
          action: "cancel_vessel_call",
          entityType: "vessel_call",
        },
        (transactionId) =>
          cancelVesselCallById({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => handleSuccess("CANCELLED"),
    onError: (error: VesselCallError) => handleError(error),
  });

  const cancelCall = ({
    service,
    vesselCallId,
    payload,
  }: {
    service: string;
    vesselCallId: string;
    payload: CancelVesselCallByIdArgs;
  }) => {
    cancelCallMutation.mutate({ service, vesselCallId, payload });
  };

  return { cancelCall };
};
